import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'caseRepaymentController';
export default {
    /**
     * 新增还款记录
     */
    addCaseRepayment: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'addCaseRepayment',
        type: requestType.Post,
    },
    /**
     * 新增还款记录批量
     */
    addCaseRepaymentBatch: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'addCaseRepaymentBatch',
        type: requestType.Post,
    },
    /**
     * 还款记录查询
     */
    selectCaseRepayment: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'selectCaseRepayment',
        type: requestType.Get
    },
    /**
     * 导出还款记录
     */
    exportCaseRepayment: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'exportCaseRepayment',
        type: requestType.Get
    },
    /**
     * 还款总金额统计
     */
    caseRepaymentAmount: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseRepaymentAmount',
        type: requestType.Get
    },
    /**
     * 新增还款申请
     */
    addCaseRepaymentApply: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'addCaseRepaymentApply',
        type: requestType.Post,
    },
    /**
     * 获取收款账户
     */
    getReceiveAccount: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getReceiveAccount',
        type: requestType.Get
    },
    /**
     * 回款列表
     */
    getAllPaymentConfirmationList: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getAllPaymentConfirmationList',
        type: requestType.Get
    },
    /**
     * 回款确认
     */
    confirmCaseRepaymentApply: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'confirmCaseRepaymentApply',
        type: requestType.Post
    },
    /**
     * 回款明细报表
     */
    getCaseRepaymentDetailReport: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCaseRepaymentDetailReport',
        type: requestType.Get
    },
    /**
     * 佣金报表
     */
    getCommissionReport: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCommissionReport',
        type: requestType.Get
    },
    /**
     * 佣金报表金额统计
     */
    getCommissionReportAmount: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getCommissionReportAmount',
        type: requestType.Get
    },
    /**
     * 绩效报表
     */
    getPerformanceReport: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getPerformanceReport',
        type: requestType.Get
    },
    /**
     * 绩效报表金额统计
     */
    getPerformanceReportAmount: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getPerformanceReportAmount',
        type: requestType.Get
    },
    /**
     * 绩效报表导出
     */
    performanceReportExport: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'performanceReportExport',
        type: requestType.Get
    },
    /**
     * 佣金报表导出
     */
    commissionReportExport: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'commissionReportExport',
        type: requestType.Get
    },
    /**
     * 回款明细报表导出
     */
    caseRepaymentDetaiReportExport: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'caseRepaymentDetaiReportExport',
        type: requestType.Get
    }
};
